import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Usuario } from '../../models/usuario.model';
import { URL_SERVICIOS_INTERNA } from '../../config/config';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  usuario: Usuario;
  token: string;

  constructor(public http: HttpClient, public router: Router) {
    this.cargarStorage();
  }

  estaLogueado() {
    localStorage.setItem('id', '1');
    localStorage.setItem('usuario', JSON.stringify('{"result":{"value":[{"usuId":1,"usuUsuario":"admin","usuPassword":"3lkPy6zPfp/sF050E5Pwmra43ELo9rOO2NRYHvkJbB1DV1o7sOjubk1J/90D/t1pf8JlarAvYLFLR3FChLpyXw==","perId":1,"perNombre":"ADMINISTRADOR","usuNombre":"Ingresos","usuApellido":"Nobis","usuUltimoAcceso":"01/06/2018 2:57:34 p.m.","usuEmail":"INGRESOS@NOBISSALUD.COM.AR","usuActivo":1}],"formatters":[],"contentTypes":[],"declaredType":null,"statusCode":200},"value":null}'));
    localStorage.setItem('token', 'abc');
    return (this.token.length > 5) ? true : false;
  }

  cargarStorage() {
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');
      this.usuario = JSON.parse(localStorage.getItem('usuario'));
    } else {
      this.token = '';
      this.usuario = null;
    }
  }

  guardarStorage(id: string, token: string, usuario: Usuario) {
    localStorage.setItem('id', '1');
    localStorage.setItem('usuario', JSON.stringify('{"result":{"value":[{"usuId":1,"usuUsuario":"admin","usuPassword":"3lkPy6zPfp/sF050E5Pwmra43ELo9rOO2NRYHvkJbB1DV1o7sOjubk1J/90D/t1pf8JlarAvYLFLR3FChLpyXw==","perId":1,"perNombre":"ADMINISTRADOR","usuNombre":"Ingresos","usuApellido":"Nobis","usuUltimoAcceso":"01/06/2018 2:57:34 p.m.","usuEmail":"INGRESOS@NOBISSALUD.COM.AR","usuActivo":1}],"formatters":[],"contentTypes":[],"declaredType":null,"statusCode":200},"value":null}'));
    localStorage.setItem('token', 'abc');

    this.usuario = usuario;
    this.token = token;
  }

  login(usuario: Usuario, recordar: boolean) {
    const url = URL_SERVICIOS_INTERNA + 'api/User';

    /*
    if (recordar) {
      localStorage.setItem('email', usuario.email);
    } else {
      localStorage.removeItem('email');
    }
    */

    // cambiarlo por POST
    return this.http.get( url + '/email/password?usrEmail=' + 'ingresos@nobissalud.com' + '&usrPassword=' + '1234')
      .pipe(map( (resp: any) => {
          this.guardarStorage(resp.id, resp.token, resp.usuario);
          return true;
        }));
  }

  logout() {
    this.token = '';
    this.usuario = null;

    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('id');

    this.router.navigate(['/survery1']);
  }
}
